import { Stack } from "@chakra-ui/react";

import { PageHeader } from "../../components/shared/PageHeader";
import { OperationsPageFilters, OperationList } from "../../components/features/OperationsPage";

export function OperationsPage() {
  return (
    <Stack spacing={0} minH="100svh">
      <PageHeader title="История операций" />

      <OperationsPageFilters />
      <OperationList />
    </Stack>
  );
}
